/**
 * Named Google Places field lists. Changing a mask is a reviewable diff.
 *
 * Client Autocomplete/Details stay Essentials-like. Never add rating,
 * priceLevel, photos, phones, hours, or websiteUri here — those are Enterprise
 * and belong only on the Agency/Bespoke server browse route.
 */

export const PLACE_DETAIL_FIELDS = ['name', 'formatted_address', 'geometry', 'place_id'];

export const PLACE_AUTOCOMPLETE_TYPES = ['establishment', 'geocode'];

export const PLACE_AUTOCOMPLETE_MIN_CHARS = 3;

export const PLACE_AUTOCOMPLETE_DEBOUNCE_MS = 300;
